import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import FieldLabelWrapper from '../../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../../../components/Form/Field'

import { ETHNICITY_PERCENTAGE, ethnicityFields, STAKEHOLDERS_LIST } from '../../../../../../../stakeholdersFields'

import useStyles from '../../styles'
import useEthnicityStyles from '../styles'

const SaudiArabiaEthnicityFields = ({ formik, index }) => {
  const { t } = useTranslation()

  const classes = useStyles()
  const ethnicityClasses = useEthnicityStyles()

  const ethnicityPath = `${STAKEHOLDERS_LIST}[${index}][${ETHNICITY_PERCENTAGE}]`

  return (
    <FieldLabelWrapper label={t('Ethnicity')}>
      <div className={classnames(classes.row, ethnicityClasses.ethnicityRow)}>
        <FieldLabelWrapper
          label={t('Local Saudi %')}
          className={classnames(classes.subLevelFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${ethnicityPath}[${ethnicityFields.local}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
          />
        </FieldLabelWrapper>
        <FieldLabelWrapper
          label={t('Non-local Saudi %')}
          className={classnames(classes.subLevelFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${ethnicityPath}[${ethnicityFields.non_local}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
          />
        </FieldLabelWrapper>
        <FieldLabelWrapper
          label={t('International %')}
          className={classnames(classes.subLevelFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${ethnicityPath}[${ethnicityFields.international}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
          />
        </FieldLabelWrapper>
        <FieldLabelWrapper
          label={t('Unknown %')}
          className={classnames(classes.subLevelFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${ethnicityPath}[${ethnicityFields.unknown}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
          />
        </FieldLabelWrapper>
      </div>
    </FieldLabelWrapper>
  )
}

SaudiArabiaEthnicityFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default SaudiArabiaEthnicityFields
